import type { CalibrationProfile, DisplayViewportMetrics, Point, Scene, ViewTransform } from "../types";

export interface PlayerViewport {
  center: Point;
  width: number;
  height: number;
}

export function defaultPlayerCenter(scene: Scene): Point {
  const width = scene.geometry?.width ?? 24; const height = scene.geometry?.height ?? 16;
  return { x: width / 2, y: height / 2 };
}

export function playerViewport(scene: Scene, calibration?: CalibrationProfile, requestedCenter?: Point, displayViewport?: DisplayViewportMetrics): PlayerViewport {
  const mapWidth = scene.geometry?.width ?? 24; const mapHeight = scene.geometry?.height ?? 16;
  const pixelsPerInch = calibration?.pixelsPerInch ?? 96;
  const physicalGridPixels = Math.max(1, pixelsPerInch * scene.gridInches);
  const displayWidth = displayViewport?.width ?? calibration?.width ?? 1280;
  const displayHeight = displayViewport?.height ?? calibration?.height ?? 720;
  const quarterTurn = scene.view.rotation === 90 || scene.view.rotation === 270;
  const width = Math.min(mapWidth, (quarterTurn ? displayHeight : displayWidth) / physicalGridPixels);
  const height = Math.min(mapHeight, (quarterTurn ? displayWidth : displayHeight) / physicalGridPixels);
  const source = requestedCenter ?? scene.playerView?.center ?? defaultPlayerCenter(scene);
  return {
    center: {
      x: width >= mapWidth ? mapWidth / 2 : Math.max(width / 2, Math.min(mapWidth - width / 2, source.x)),
      y: height >= mapHeight ? mapHeight / 2 : Math.max(height / 2, Math.min(mapHeight - height / 2, source.y)),
    },
    width,
    height,
  };
}

export function playerViewTransform(scene: Scene, calibration?: CalibrationProfile, showFitScreen = false, displayViewport?: DisplayViewportMetrics): ViewTransform {
  if (showFitScreen) return { x: 0, y: 0, zoom: 1, rotation: scene.view.rotation, mode: "fit" };
  const viewport = playerViewport(scene, calibration, undefined, displayViewport);
  return {
    x: (scene.geometry?.width ?? 24) / 2 - viewport.center.x,
    y: (scene.geometry?.height ?? 16) / 2 - viewport.center.y,
    zoom: 1,
    rotation: scene.view.rotation,
    mode: "physical",
  };
}
